import { render, staticRenderFns } from "./BFormInputDate.vue?vue&type=template&id=bdff4a0a&scoped=true"
import script from "./BFormInputDate.vue?vue&type=script&lang=js"
export * from "./BFormInputDate.vue?vue&type=script&lang=js"
import style0 from "./BFormInputDate.vue?vue&type=style&index=0&id=bdff4a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdff4a0a",
  null
  
)

export default component.exports